common.View.create('website::layouts.Main', {

        onDOMLoad()
    {
        this.checkAnimations();
    },

    checkAnimations() {
        // Check window width and based on that we change the data-sal-duration attribute.
        let salDuration = window.innerWidth < 768 ? '500' : '750';
        // let salEasing = 'ease';
        // let salType = 'slide-up';
        let salElements = document.querySelectorAll('[data-sal]');

        if (salElements.length > 0) {
            salElements.forEach((element) => {
                element.setAttribute('data-sal-duration', salDuration);
                // element.setAttribute('data-sal-easing', salEasing);
                // element.setAttribute('data-sal', salType);
            });
        }

        this.setAnimations();
    },

    setAnimations() {
        let sal = require('sal.js');
        
        sal({
            threshold: 0.1,
            once: true,
        });
    }

});
